<template>
  <v-main>
    <v-row>
      <v-col>
        <v-card-title>
          Program List
          <v-spacer></v-spacer>
        </v-card-title>
      </v-col>
      <v-col>
        <v-checkbox
            label="Only Enable"
            value="false"
            v-model="isAll"
            @change="changeIsAll()"
        ></v-checkbox>
      </v-col>
      <v-col>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
            :headers="headers"
            :items="desserts"
            :single-expand="singleExpand"
            :expanded.sync="expanded"
            item-key="name"
            show-expand
            class="elevation-1"
            fixed-header
            :loading="loadPrograms"
            :search="search"
            :footer-props="{
    'items-per-page-options': [50, 100 , 200, -1]
  }"
        >
          <template v-slot:item.provider="{ item }">
            <a :href="item.url" style="text-decoration: none" target="_blank">
              <v-btn
                  small
                  text
                  color="primary"
              >
                {{ item.provider }}
              </v-btn>
            </a>
          </template>
          <template v-slot:item.created_at="{ item }">
              {{ timeConverter(item.created_at) }}
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-icon>mdi-arrow-right-thin</v-icon>
              oos: {{ item.out_of_scope_domains }}
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-icon>mdi-arrow-right-thin</v-icon>
              m-oos: {{ item.manual_out_of_scope_domains }}
              <v-spacer></v-spacer>
            </td>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
                small
                @click="sendToFuzzer(item)"
                text
                color="primary"
            >
              Detail
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-main>
</template>

<script>
export default {
  name: "ProgramList",
  data() {
    return {
      snackbar: false,
      isAll: true,
      loadPrograms: true,
      expanded: [],
      singleExpand: true,
      search: "",
      headers: [
        {text: 'Name', value: "name"},
        {text: 'Provider', value: "provider"},
        {text: 'Created At', value: "created_at"},
        {text: 'Actions', value: "actions", sortable: false},
        {text: '', value: 'data-table-expand'},
      ],
      desserts: [],
    }
  },
  methods: {
    changeIsAll: function () {
      this.loadPrograms = true
      this.desserts = []
      if (this.isAll == null) {
        this.isAll = true
      }

      this.axios.get('https://isee.sh:2087/scope/data/list?full=true&all=' + this.isAll).then(response => {
        this.desserts = response.data
        this.loadPrograms = false
      })
    },
    timeConverter: function (UNIX_timestamp) {
      const a = new Date(UNIX_timestamp * 1000);
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const year = a.getFullYear();
      const month = months[a.getMonth()];
      const date = a.getDate();
      const hour = a.getHours();
      const min = a.getMinutes();
      const sec = a.getSeconds();
      const time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec;
      return time;
    }
  },
  mounted() {
    this.axios.get('https://isee.sh:2087/scope/data/list?full=true&all=' + this.isAll).then(response => {
      this.desserts = response.data
      this.loadPrograms = false
    })
  },
}


</script>

<style scoped>


</style>
